import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';

import PrimaryButton from '../components/PrimaryButton';
import AutoNavigate from '../components/AutoNavigate';
import RideIdlePage from './protected/ride/idle.jsx';
import { defaultApiClient } from '../apiClients/apiClient.js';

export default function HomePage() {
    const navigate = useNavigate();

    const isLoggedIn = defaultApiClient.isLoggedIn();

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1_000);

        return () => clearTimeout(timer);
    }, []);

    if (isLoggedIn) {
        return <RideIdlePage />;
    }

    if (isLoading) {
        return (
            <Box
                sx={{
                    width: '100vw',
                    height: '100dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <AutoNavigate delay={500} />
                <img src="/maskable_icon.png" style={{ width: 192, height: 192 }} />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <AutoNavigate delay={1_000} />

            <img src="/text-icon-high-res.png" style={{ height: '7vh' }} />
            <img src="/introduction-screen-main-image.png" style={{ height: '29vh' }} />
            <img src="/introduction-screen-features-list-image.png" style={{ height: '29vh' }} />
            <PrimaryButton
                text="Sign in with Phone Number"
                fontSizeOverride={16}
                onClick={() => navigate('/auth/request-login-otp')}
                loading={isLoading}
            />
        </Box>
    );
}
